import { Component, OnInit, Input } from '@angular/core';
import { ModalController, LoadingController, AlertController } from '@ionic/angular';
import { Client, Communication } from 'src/app/models';
import { ClientService } from '../../../services/client.service';
import { Utilities } from '../../../utilities/utilities';

@Component({
  selector: 'app-client-communication-history',
  templateUrl: './client-communication-history.component.html',
  styleUrls: ['./client-communication-history.component.scss'],
})
export class ClientCommunicationHistoryComponent  implements OnInit {

  @Input() communication: Communication;

  @Input()  client: Client;

  public decodedContent: string;

  constructor(public modalCtrl: ModalController, public loadingCtrl: LoadingController, private clientService: ClientService, public alertCtrl: AlertController) { 



  }

  ngOnInit() {
    this.decodedContent = this.communication.message
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&amp;/g, '&');

  }


  public onDismiss(){
    this.modalCtrl.dismiss()
  }

  public async resend () {
    const loader = await this.loadingCtrl.create({ spinner: 'crescent'});
    loader.present();
    this.clientService.reSendCommunicationHistory(this.client, this.communication)
      .subscribe((communication: Communication) => {
        loader.dismiss().then(() => {
          this.modalCtrl.dismiss(communication);
        });
      },
      (err) => { 
        loader.dismiss(async () => {
          const alert = await this.alertCtrl.create(Utilities.getDefaultErrorMessageConfig())
          alert.present();
        });
      });
  }
}
